var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"videomonitoring"}},[_c('div',[_c('el-card',{},[_c('div',{},[_c('div',{staticClass:"prism-player",style:(_vm.playStyle),attrs:{"id":_vm.playerId}})])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }